__turbopack_context__.v({
  "card": "WBoxInformations-module__5oJuvW__card",
  "cardLink": "WBoxInformations-module__5oJuvW__cardLink",
  "grid": "WBoxInformations-module__5oJuvW__grid",
  "iconWrap": "WBoxInformations-module__5oJuvW__iconWrap",
  "name": "WBoxInformations-module__5oJuvW__name",
  "root": "WBoxInformations-module__5oJuvW__root",
  "text": "WBoxInformations-module__5oJuvW__text",
});
